import { Typography } from '@mui/material';

type CommonCardContentProps = {
    content: string
}

export function CommonCardContent({
    content
}: Readonly<CommonCardContentProps>) {
    return (
        <Typography
            align='left'
            variant='body1'
            color='text.primary'
            sx={{
                fontSize: '16px'
            }}
        >{content}
        </Typography>
    );
}
